import HeaderBlock from 'modules/profile/user-plan/components/price-plan-columns/components/header-block'
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum'
import {
  UseUserPlanInterface,
  UserPlanInterface,
  tableFeatures,
} from 'modules/profile/user-plan/types/user-plan-interface'
import { getPricePlanFeatureTitle } from 'modules/profile/user-plan/utils/price-plan-utils'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export interface UserPlanColumnProps {
  pricePlan: UserPlanInterface
  billingPeriod: BillingPeriodEnum
  isOneClickUpgradeAvailable: boolean
  paymentMethod: UseUserPlanInterface['customer']['paymentMethod']
  isPlanUpgradeAvailable: boolean
  showWithTax: boolean
}

const UserPlanColumn = ({
  pricePlan,
  billingPeriod,
  isOneClickUpgradeAvailable,
  paymentMethod,
  isPlanUpgradeAvailable,
  showWithTax,
}: UserPlanColumnProps) => {
  const { t } = useLocoTranslation()

  return (
    <div className="slideScrollSnapAlignStart flex w-full min-w-full flex-col gap-2 border border-transparent lg:grid">
      <HeaderBlock
        pricePlan={pricePlan}
        billingPeriod={billingPeriod}
        isOneClickUpgradeAvailable={isOneClickUpgradeAvailable}
        paymentMethod={paymentMethod}
        isPlanUpgradeAvailable={isPlanUpgradeAvailable}
        showWithTax={showWithTax}
      />
      {tableFeatures.map((column, index) => (
        <React.Fragment key={`column-${column.key}`}>
          <div className="text-text-primary font-inter truncate text-center text-base">
            {getPricePlanFeatureTitle({ pricePlan, key: column.key, t })}
          </div>
          {tableFeatures[index + 1] ? (
            <hr className="border-fill-primary -mr-6 border-solid" />
          ) : (
            <div />
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export default UserPlanColumn
